import { Injectable } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { AuthConfig } from '@auth/auth.config';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(
    private _auth: AuthService
  ) { }

  get HomePath(): string {
    let path: string = AuthConfig.paths.home;
    if (this._auth.hasPermission("location", { explicit: true })) {
      path = AuthConfig.paths.locations
    }
    return path
  }

  get LoginPath(): string {
    return AuthConfig.paths.login
  }

  get ForbiddenPath(): string {
    return AuthConfig.paths.error.forbidden
  }

}
